import { ChangeEvent, ForwardedRef, forwardRef, memo, Ref } from 'react';
import AddIcon from '@mui/icons-material/Add';

import SelectFileButton from '@/dmdrive/ui-kit/components/SelectFileButton/SelectFileButton';

interface Upload3DModelButtonProps {
  title?: string;
  onSelectFile?: (files: Nullable<File[]>, e: ChangeEvent<HTMLInputElement>) => void;
  linkRef?: Ref<HTMLLabelElement>;
}

function Upload3DModelButton(props: Upload3DModelButtonProps, ref: ForwardedRef<HTMLInputElement>) {
  const { title = 'Import 3D model', linkRef, onSelectFile } = props;

  return (
    <SelectFileButton
      ref={ref}
      linkRef={linkRef}
      title={title}
      accept=".cbr"
      variant="contained"
      startIcon={<AddIcon />}
      onChange={onSelectFile}
      multiple
    />
  );
}

export default memo(forwardRef(Upload3DModelButton));
